export default __webpack_public_path__ + "static/6764-ffc05c1f9e7192dc8836368d054d1b55.jpg";